import { ResearchType } from '@empathy/global/data';

export const ResearchMethodIcon = (method: ResearchType): string => {
  switch (method) {
    case ResearchType.Survey:
      return 'quantitative-research';
    case ResearchType.DiscussionForum:
      return 'research-method-discussion-forum';
    case ResearchType.AIInterview:
      return 'qualitative-research';
    default:
      break;
  }
};
